import { createReducer, on } from '@ngrx/store';
import { profileActions } from '../actions/profile.actions';
import { User } from '../models';

export interface ProfileState {
    loaded: boolean | null;
    loading: boolean | null;
    profile: User | null;
}

export const initialState: ProfileState = {
    loaded: null,
    loading: null,
    profile: null,
};

export const profileReducer = createReducer(
    initialState,
    // Get
    on(profileActions.getProfile, (state): ProfileState => ({
        ...state,
        loading: true,
        loaded: null,
    })),
    on(profileActions.getProfileSuccess, (state, { payload }): ProfileState => ({
        ...state,
        loading: false,
        loaded: true,
        profile: payload,
    })),
    on(profileActions.getProfileError, (state): ProfileState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    // Language
    on(profileActions.updateLanguageSuccess, (state, { payload }): ProfileState => ({
        ...state,
        profile: payload,
    })),
    // Clear
    on(profileActions.clear, (): ProfileState => ({ ...initialState })),
);
